(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
window.KMDGPB = window.KMDGPB || {};
window.KMDGPB.jQuery = jQuery.noConflict();

function PBuilder() {
    console.info('Builder Loaded');
    this.mobileSize = 800;
}

(function (jQuery) {
    require("./vendor/materialize/parallax");
    require("./vendor/waypoints/waypoint");
    require("./vendor/waypoints/group");
    require("./vendor/waypoints/context");
    require("./vendor/waypoints/adapters/jquery");
    require("./vendor/waypoints/shortcuts/inview");
    require("./vendor/waypoints/shortcuts/sticky");
    require("./vendor/jquery.smoothwheel/jquery.smoothwheel");
    require("./vendor/jquery.cycle2/jquery.cycle2");
    require("./vendor/jquery.cycle2/jquery.cycle2.tile");
    require("./vendor/jquery.cycle2/jquery.cycle2.swipe");
    require("./vendor/jquery.cycle2/jquery.cycle2.carousel");
    require("./vendor/jquery.cycle2/jquery.cycle2.scrollVert");
    require("./vendor/jquery.cycle2/jquery.cycle2.fadeInUp");

    // Components
    require("./components/image");
    require("./components/accordion");
    require("./components/video");
})(KMDGPB.jQuery);

(function($) {
    PBuilder.prototype.detectIE = function() {
        var ua = window.navigator.userAgent;

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    };

    PBuilder.prototype.equalizeHeights = function(group, parent) {
        parent = parent || "body";
        jQuery(parent).each(function() {
            var tallest = 0;
            jQuery(this).find(group).css('min-height', 0);

            jQuery(this).find(group).each(function() {
                var $this = jQuery(this);
                var thisHeight = $this.height();

                if($this.css('box-sizing') === 'content-box') {
                    if(thisHeight > tallest) {
                        tallest = thisHeight;
                    }
                } else {
                    var thisPadding = Number($this.css('padding-top').replace('px', ''))
                        + Number($this.css('padding-bottom').replace('px', ''));

                    if((thisHeight + thisPadding) > tallest) {
                        tallest = thisHeight + thisPadding;
                    }
                }
            });
            jQuery(this).find(group).css('min-height',tallest);
        });
    };

    PBuilder.prototype.animationTriggerEnter = function(el) {
        var mobileSize = this.mobileSize;
        var $components = $(el).find('.builder-component');

        $components.each(function(i, el) {
            $(window).trigger("builderAnimationStart", [el]);
        });

        $(el).find('.builder-component-animated').each(function(i, component) {
            var type = $(component).attr("data-animation");
            var delay = ($(component).attr("data-animation-delay") || 0) + 's';
            var loop = $(component).attr("data-animation-loop");
            var visibility = $(component).attr("data-animation-visibility");
            var mobile = $(component).attr("data-animation-mobile") || 'normal';

            if($(window).width() <= mobileSize) {
                if(mobile == 'normal') {
                    $(component).css('animation-delay', delay);
                } else if(mobile == 'none') {
                    $(component).removeClass('builder-animation-hidden');
                    return;
                } else {
                    $(component).css('animation-delay', "0s");
                }
            } else {
                $(component).css('animation-delay', delay);
            }

            if(visibility == 'hide') {
                $(component).one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function() {
                    $(component).addClass('builder-animation-hidden');
                });
            }

            if(loop == "infinite") {
                $(component).addClass("infinite");
            }

            $(component)
                .addClass(type)
                .addClass('animated')
                .removeClass('builder-animation-hidden');
        });
    };

    PBuilder.prototype.animationPause = function(el) {
        var mobileSize = this.mobileSize;

        $(el).find('.builder-component-animated').each(function(i, component) {
            var mobile = $(component).attr("data-animation-mobile") || 'normal';

            if(mobile == 'none' && $(window).width() <= mobileSize) return;

            if($(component).hasClass('animated')) {
                $(component).addClass('disable-animation');
                $(component).removeClass('animated');
            }
        });
    };

    PBuilder.prototype.animationUnpause = function(el) {
        var mobileSize = this.mobileSize;

        $(el).find('.builder-component-animated').each(function(i, component) {
            var mobile = $(component).attr("data-animation-mobile") || 'normal';

            if(mobile == 'none' && $(window).width() <= mobileSize) return;

            if($(component).hasClass('disable-animation')) {
                $(component).addClass('animated');
                $(component).removeClass('disable-animation');
            }
        });
    };

    PBuilder.prototype.animationTriggerExit = function(el) {
        var mobileSize = this.mobileSize;
        var $components = $(el).find('.builder-component');

        $components.each(function(i, el) {
            $(window).trigger("builderAnimationEnd", [el]);
        });

        $(el).find('.builder-component-animated').each(function(i, component) {
            var type = $(component).attr("data-animation");
            var loop = $(component).attr("data-animation-loop");
            var visibility = $(component).attr("data-animation-visibility");
            var mobile = $(component).attr("data-animation-mobile") || 'normal';

            if(mobile == 'none' && $(window).width() <= mobileSize) return;

            if (loop != "infinite") {
                $(component).removeClass('animated');

                if (loop != "once") {
                    $(component).removeClass(type)

                    if(visibility == 'hidden') {
                        $(component).addClass('builder-animation-hidden');
                    } else if(visibility == 'hide') {
                        $(component).removeClass('builder-animation-hidden');
                    }
                }
            }
        });
    };

    PBuilder.prototype.breakout = function(element) {
        var $element = $(element);

        if($element.length > 0) {
            var windowW = document.documentElement.clientWidth;

            $element.css({"margin-left": 0, "display": "block", "visibility": "hidden"});

            var pos = $element.offset();
            $element.css({"width": windowW, "margin-left": -pos.left});

            $element.find(".builder-container").css("max-width", windowW - (pos.left * 2));
            $element.css('visibility', 'visible');
        }
    };

    PBuilder.prototype.loadBG = function($el) {
        if($el.hasClass('loaded') || $el.hasClass('loading') || !$el.attr('data-srcs')) return;

        $el.addClass('loading');

        var $parent = $el.parent();
        var sizes = JSON.parse($el.attr('data-srcs'));
        var bestFit = {size: null, width: 999999999};

        for(var i in sizes) {
            if(sizes[i].width == -1) {
                sizes[i].width = $parent.width() * 100;
            }

            if(sizes[i].width >= $parent.width() && sizes[i].width < bestFit.width) {
                bestFit = {
                    size: i,
                    width: sizes[i].width
                };
            }
        }

        var preload = new Image();
        preload.src = sizes[bestFit['size']].src;

        preload.addEventListener('load', function() {
            $el.css('background-image', 'url(' + preload.src + ')').addClass('loaded').removeClass('loading');
        });
    };
})(KMDGPB.jQuery)

window.KMDGPB.builder = new PBuilder();

(function ($, builder) {
    $('.builder-parallax .builder-parallax-container').parallax();

    // Hijack scrolling on IE/Edge because it's terrible
    if(builder.detectIE() !== false) {
        $(window).on('load', function() {
            $(window).smoothWheel();
        });
    }

    // Force selected sections to go full width despite container size
    $(window).on('load ready resize', function() {
        builder.breakout('.builder-section.builder-breakout');
        builder.equalizeHeights('.builder-block-slide .builder-section', '.builder-block-slider');
    });

    // Trigger a scroll event on page load to make sure parallax is updated
    $(window).scroll();
    $(window).on('load', function() {
        $(window).scroll();
    });

    // Equalize heights of components in the same "row" (option)
    $(window).on('load', function() {
        $('.builder-section.builder-js-equalize .builder-layout').each(function(i, layout) {
            $(layout).find('.builder-column').each(function(i, column) {
                $(column).find('.builder-component').each(function(i, component) {
                    builder.equalizeHeights(".builder-component-index-" + (i + 1), $(layout));
                });
            });
        });
    });

    $(window).on('load', function() {

        $('.builder-section, .builder-block-slider').not('.builder-section-type--block-slide').each(function(i, section) {
            var $section = $(section);

            $section.data("animSettings", new Waypoint.Inview({
                element: $section,
                enter: function(dir) {
                    $section.trigger('builderSectionOnScreen', [$section]);
                },
                exited: function(dir) {
                    $section.trigger('builderSectionOffScreen', [$section]);
                }
            }));

            $section.find('.builder-column, .builder-bg-image-wrap--animated').each(function(i, column) {
                var $column = $(column);

                // Create animation trigger element
                $column.prepend('<div class="builder-js-animation-trigger"></div>');
                var animTrigger = $column.children('.builder-js-animation-trigger');

                // Scroll Watcher for animations and videos, Waypoints stored in DOM data for each column
                $column.data("animSettings", new Waypoint.Inview({
                    element: animTrigger,
                    entered: function(dir) {
                        builder.animationTriggerEnter($column);
                    },
                    exited: function(dir) {
                        builder.animationTriggerExit($column);
                    }
                }));
            });
        });
    });

    if(KMDGPB.adminUrl) {
        // Add edit links to blocks for admin users.
        $(window).on('load', function() {
            $('.builder-section[data-block]').each(function(i, el) {
                var $el = $(el);
                var pid = $el.attr("data-block");
                var link = `${KMDGPB.adminUrl}post.php?post=${pid}&action=edit`;
                $el.append(`<a class="builder-block-edit" href="${link}" target="_blank">Edit Block</a>`);
            });
        });
    }

    $('.builder-block-slider').cycle({
        slides: '> .builder-block-slide',
        swipe: true,
        swipeFx: 'scrollHorz',
        autoHeight: 'calc',
        log: false
    }).on('cycle-after', function(event, optionHash, outgoingSlideEl, incomingSlideEl) {

        // Previous slide tracking (used for some bugfixes)
        $(outgoingSlideEl).parent().find('.builder-cycle--previous').removeClass('builder-cycle--previous');
        $(outgoingSlideEl).addClass('builder-cycle--previous');

        // Trigger animations on incomming slides
        $(incomingSlideEl).trigger('builderSectionOnScreen', [incomingSlideEl]);
        builder.animationTriggerEnter(incomingSlideEl);

    }).on('cycle-before', function(event, optionHash, outgoingSlideEl, incomingSlideEl) {
        var speed = $(this).data('cycle.opts').speed;

        // Pause animations while transitioning out
        builder.animationPause(outgoingSlideEl);

        setTimeout(function() {
            $(outgoingSlideEl).trigger('builderSectionOffScreen', [outgoingSlideEl]);

            // Reset animation states
            builder.animationUnpause(outgoingSlideEl);
            builder.animationTriggerExit(outgoingSlideEl);
        }, speed);
    });

    $('.builder-bg-image-slideshow').cycle({
        slides: '> .builder-img-bg',
        autoHeight: false,
        swipe: false,
        pauseOnHover: false,
        timeout: 5000
    });

    builder.loadBG($('.builder-img-bg:first'));

    $('.builder-section, .builder-slider--has-background').on('builderSectionOnScreen', function(ev, section) {
        $(section).find('.builder-img-bg, .builder-lazy-img').each(function(i, el) {
            builder.loadBG($(el));
        });
    });

})(KMDGPB.jQuery, KMDGPB.builder);
},{"./components/accordion":2,"./components/image":3,"./components/video":4,"./vendor/jquery.cycle2/jquery.cycle2":7,"./vendor/jquery.cycle2/jquery.cycle2.carousel":5,"./vendor/jquery.cycle2/jquery.cycle2.fadeInUp":6,"./vendor/jquery.cycle2/jquery.cycle2.scrollVert":8,"./vendor/jquery.cycle2/jquery.cycle2.swipe":9,"./vendor/jquery.cycle2/jquery.cycle2.tile":10,"./vendor/jquery.smoothwheel/jquery.smoothwheel":11,"./vendor/materialize/parallax":12,"./vendor/waypoints/adapters/jquery":13,"./vendor/waypoints/context":14,"./vendor/waypoints/group":15,"./vendor/waypoints/shortcuts/inview":16,"./vendor/waypoints/shortcuts/sticky":17,"./vendor/waypoints/waypoint":18}],2:[function(require,module,exports){
// Toggle accordion
(function($) {
    $('.builder-layout-accordion .builder-column-header').on('click', function() {
        var $column = $(this).parent();
        $column.toggleClass('open');
        $column.find('.builder-column-body').slideToggle({
            duration: 250,
            progress: function() {
                $(window).trigger('resize');
            }
        });
    });
})(jQuery)

},{}],3:[function(require,module,exports){

// use srcset property (if possible) to get the appropriate image size to use as a background image
// (function($) {
//     $(window).on("load", function() {
//         $('.builder-component-image .image-container').each(function(i, el) {
//             var img = $(el).find('img')[0];
//             var bg = img.currentSrc || img.src;
//             $(el).css('background-image', 'url('+bg+')');
//         });
//     });
// })(jQuery)

},{}],4:[function(require,module,exports){
//
(function($) {

    //Events thrown by builder.js in waypoint code
    $('.builder-component-video.js-autoplay').on('builderAnimationStart', function(e) {
        var video = $(this).find('video')[0];

        if($(this).data("played") !== true || $(video).attr('loop')) {
            $(this).data("played", true);
            video.play();
        }
    });

    $('.builder-component-video').on('builderAnimationEnd', function(e) {
        var video = $(this).find('video')[0];

        if($(video).attr('loop')) {
            video.pause();
        }
    });

})(jQuery)

},{}],5:[function(require,module,exports){
/*! carousel transition plugin for Cycle2;  version: 20130528 */
(function($) {
    "use strict";

    $( document ).on('cycle-bootstrap', function( e, opts, API ) {
        if ( opts.fx !== 'carousel' )
            return;

        API.getSlideIndex = function( el ) {
            var slides = this.opts()._carouselWrap.children();
            var i = slides.index( el );
            return i % slides.length;
        };

        // override default 'next' function
        API.next = function() {
            var count = opts.reverse ? -1 : 1;
            if ( opts.allowWrap === false && ( opts.currSlide + count ) > opts.slideCount - opts.carouselVisible )
                return;
            opts.API.advanceSlide( count );
            opts.API.trigger('cycle-next', [ opts ]).log('cycle-next');
        };

    });


    $.fn.cycle.transitions.carousel = {
        // transition API impl
        preInit: function( opts ) {
            opts.hideNonActive = false;

            opts.container.on('cycle-destroyed', $.proxy(this.onDestroy, opts.API));
            // override default API implementation
            opts.API.stopTransition = this.stopTransition;

            // issue #10
            for (var i=0; i < opts.startingSlide; i++) {
                opts.container.append( opts.slides[0] );
            }
        },

        // transition API impl
        postInit: function( opts ) {
            var i, j, slide, pagerCutoffIndex, wrap;
            var vert = opts.carouselVertical;
            if (opts.carouselVisible && opts.carouselVisible > opts.slideCount)
                opts.carouselVisible = opts.slideCount - 1;
            var visCount = opts.carouselVisible || opts.slides.length;
            var slideCSS = { display: vert ? 'block' : 'inline-block', position: 'static' };

            // required styles
            opts.container.css({ position: 'relative', overflow: 'hidden' });
            opts.slides.css( slideCSS );

            opts._currSlide = opts.currSlide;

            // wrap slides in a div; this div is what is animated
            wrap = $('<div class="cycle-carousel-wrap"></div>')
                .prependTo( opts.container )
                .css({ margin: 0, padding: 0, top: 0, left: 0, position: 'absolute' })
                .append( opts.slides );

            opts._carouselWrap = wrap;

            if ( !vert )
                wrap.css('white-space', 'nowrap');

            if ( opts.allowWrap !== false ) {
                // prepend and append extra slides so we don't see any empty space when we
                // near the end of the carousel.  for fluid containers, add even more clones
                // so there is plenty to fill the screen
                // @todo: optimzie this based on slide sizes

                for ( j=0; j < (opts.carouselVisible === undefined ? 2 : 1); j++ ) {
                    for ( i=0; i < opts.slideCount; i++ ) {
                        wrap.append( opts.slides[i].cloneNode(true) );
                    }
                    i = opts.slideCount;
                    while ( i-- ) { // #160, #209
                        wrap.prepend( opts.slides[i].cloneNode(true) );
                    }
                }

                wrap.find('.cycle-slide-active').removeClass('cycle-slide-active');
                opts.slides.eq(opts.startingSlide).addClass('cycle-slide-active');
            }

            if ( opts.pager && opts.allowWrap === false ) {
                // hide "extra" pagers
                pagerCutoffIndex = opts.slideCount - visCount;
                $( opts.pager ).children().filter( ':gt('+pagerCutoffIndex+')' ).hide();
            }

            opts._nextBoundry = opts.slideCount - opts.carouselVisible;

            this.prepareDimensions( opts );
        },

        prepareDimensions: function( opts ) {
            var dim, offset, pagerCutoffIndex, tmp, j;
            var vert = opts.carouselVertical;
            var visCount = opts.carouselVisible || opts.slides.length;

            if ( opts.carouselFluid && opts.carouselVisible ) {
                if ( ! opts._carouselResizeThrottle ) {
                    // fluid container AND fluid slides; slides need to be resized to fit container
                    this.fluidSlides( opts );
                }
            }
            else if ( opts.carouselVisible && opts.carouselSlideDimension ) {
                dim = visCount * opts.carouselSlideDimension;
                opts.container[ vert ? 'height' : 'width' ]( dim );
            }
            else if ( opts.carouselVisible ) {
                dim = visCount * $(opts.slides[0])[vert ? 'outerHeight' : 'outerWidth'](true);
                opts.container[ vert ? 'height' : 'width' ]( dim );
            }
            // else {
            //     // fluid; don't size the container
            // }

            offset = ( opts.carouselOffset || 0 );
            if ( opts.allowWrap !== false ) {
                if ( opts.carouselSlideDimension ) {
                    offset -= ( (opts.slideCount + opts.currSlide) * opts.carouselSlideDimension );
                }
                else {
                    // calculate offset based on actual slide dimensions
                    tmp = opts._carouselWrap.children();
                    for (j=0; j < (opts.slideCount + opts.currSlide); j++) {
                        offset -= $(tmp[j])[vert?'outerHeight':'outerWidth'](true);
                    }
                }
            }

            opts._carouselWrap.css( vert ? 'top' : 'left', offset );
        },

        fluidSlides: function( opts ) {
            var timeout;
            var slide = opts.slides.eq(0);
            var adjustment = slide.outerWidth() - slide.width();
            var prepareDimensions = this.prepareDimensions;

            // throttle resize event
            $(window).on( 'resize', resizeThrottle);

            opts._carouselResizeThrottle = resizeThrottle;
            onResize();

            function resizeThrottle() {
                clearTimeout( timeout );
                timeout = setTimeout( onResize, 20 );
            }

            function onResize() {
                opts._carouselWrap.stop( false, true );
                var slideWidth = opts.container.width() / opts.carouselVisible;
                slideWidth = Math.ceil( slideWidth - adjustment );
                opts._carouselWrap.children().width( slideWidth );
                if ( opts._sentinel )
                    opts._sentinel.width( slideWidth );
                prepareDimensions( opts );
            }
        },

        // transition API impl
        transition: function( opts, curr, next, fwd, callback ) {
            var moveBy, props = {};
            var hops = opts.nextSlide - opts.currSlide;
            var vert = opts.carouselVertical;
            var speed = opts.speed;

            // handle all the edge cases for wrapping & non-wrapping
            if ( opts.allowWrap === false ) {
                fwd = hops > 0;
                var currSlide = opts._currSlide;
                var maxCurr = opts.slideCount - opts.carouselVisible;
                if ( hops > 0 && opts.nextSlide > maxCurr && currSlide == maxCurr ) {
                    hops = 0;
                }
                else if ( hops > 0 && opts.nextSlide > maxCurr ) {
                    hops = opts.nextSlide - currSlide - (opts.nextSlide - maxCurr);
                }
                else if ( hops < 0 && opts.currSlide > maxCurr && opts.nextSlide > maxCurr ) {
                    hops = 0;
                }
                else if ( hops < 0 && opts.currSlide > maxCurr ) {
                    hops += opts.currSlide - maxCurr;
                }
                else
                    currSlide = opts.currSlide;

                moveBy = this.getScroll( opts, vert, currSlide, hops );
                opts.API.opts()._currSlide = opts.nextSlide > maxCurr ? maxCurr : opts.nextSlide;
            }
            else {
                if ( fwd && opts.nextSlide === 0 ) {
                    // moving from last slide to first
                    moveBy = this.getDim( opts, opts.currSlide, vert );
                    callback = this.genCallback( opts, fwd, vert, callback );
                }
                else if ( !fwd && opts.nextSlide == opts.slideCount - 1 ) {
                    // moving from first slide to last
                    moveBy = this.getDim( opts, opts.currSlide, vert );
                    callback = this.genCallback( opts, fwd, vert, callback );
                }
                else {
                    moveBy = this.getScroll( opts, vert, opts.currSlide, hops );
                }
            }

            props[ vert ? 'top' : 'left' ] = fwd ? ( "-=" + moveBy ) : ( "+=" + moveBy );

            // throttleSpeed means to scroll slides at a constant rate, rather than
            // a constant speed
            if ( opts.throttleSpeed )
                speed = (moveBy / $(opts.slides[0])[vert ? 'height' : 'width']() ) * opts.speed;

            opts._carouselWrap.animate( props, speed, opts.easing, callback );
        },

        getDim: function( opts, index, vert ) {
            var slide = $( opts.slides[index] );
            return slide[ vert ? 'outerHeight' : 'outerWidth'](true);
        },

        getScroll: function( opts, vert, currSlide, hops ) {
            var i, moveBy = 0;

            if (hops > 0) {
                for (i=currSlide; i < currSlide+hops; i++)
                    moveBy += this.getDim( opts, i, vert);
            }
            else {
                for (i=currSlide; i > currSlide+hops; i--)
                    moveBy += this.getDim( opts, i, vert);
            }
            return moveBy;
        },

        genCallback: function( opts, fwd, vert, callback ) {
            // returns callback fn that resets the left/top wrap position to the "real" slides
            return function() {
                var pos = $(opts.slides[opts.nextSlide]).position();
                var offset = 0 - pos[vert?'top':'left'] + (opts.carouselOffset || 0);
                opts._carouselWrap.css( opts.carouselVertical ? 'top' : 'left', offset );
                callback();
            };
        },

        // core API override
        stopTransition: function() {
            var opts = this.opts();
            opts.slides.stop( false, true );
            opts._carouselWrap.stop( false, true );
        },

        // core API supplement
        onDestroy: function( e ) {
            var opts = this.opts();
            if ( opts._carouselResizeThrottle )
                $( window ).off( 'resize', opts._carouselResizeThrottle );
            opts.slides.prependTo( opts.container );
            opts._carouselWrap.remove();
        }
    };

})(jQuery);
},{}],6:[function(require,module,exports){
/*! Custom reversed scrollVert transition plugin for Cycle2; */
(function($) {
    "use strict";

    $.fn.cycle.transitions.fadeInUp = {
        postInit: function( opts ) {
            var transitionSpeed = (opts.cycleSpeed / 1000) * 2;
            opts.cssAfter = { opacity: 0 };
            opts.cssBefore = { opacity: 1, display: 'block', visibility: 'visible' , transition: 'opacity '+transitionSpeed+'s', 'transition-timing-function': 'ease-in-out'};
        },

        before: function( opts, curr, next, fwd ) {
            opts.API.stackSlides( opts, curr, next, fwd );
            var height = opts.container.css('overflow','hidden').height();
            var transitionSpeed = (opts.cycleSpeed / 1000) * 2;

            opts.cssAfter = { opacity: 0 };
            opts.cssBefore = { top: fwd ? height : -height, left: 0, opacity: 1, display: 'block', visibility: 'visible' , transition: 'opacity '+transitionSpeed+'s', 'transition-timing-function': 'ease-in-out'};
            opts.animIn = { top: 0 };
            opts.animOut = { top: fwd ? -height : height };
        },
    };

})(jQuery);
},{}],7:[function(require,module,exports){
/*!
 * jQuery Cycle2; version: 2.1.6 build: 20141007
 * http://jquery.malsup.com/cycle2/
 * Copyright (c) 2014 M. Alsup; Dual licensed: MIT/GPL
 */

/* Cycle2 core engine */
;(function($) {
    "use strict";

    var version = '2.1.6';

    $.fn.cycle = function( options ) {
        // fix mistakes with the ready state
        var o;
        if ( this.length === 0 && !$.isReady ) {
            o = { s: this.selector, c: this.context };
            $.fn.cycle.log('requeuing slideshow (dom not ready)');
            $(function() {
                $( o.s, o.c ).cycle(options);
            });
            return this;
        }

        return this.each(function() {
            var data, opts, shortName, val;
            var container = $(this);
            var log = $.fn.cycle.log;

            if ( container.data('cycle.opts') )
                return; // already initialized

            if ( container.data('cycle-log') === false ||
                ( options && options.log === false ) ||
                ( opts && opts.log === false) ) {
                log = $.noop;
            }

            log('--c2 init--');
            data = container.data();
            for (var p in data) {
                // allow props to be accessed sans 'cycle' prefix and log the overrides
                if (data.hasOwnProperty(p) && /^cycle[A-Z]+/.test(p) ) {
                    val = data[p];
                    shortName = p.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, lowerCase);
                    log(shortName+':', val, '('+typeof val +')');
                    data[shortName] = val;
                }
            }

            opts = $.extend( {}, $.fn.cycle.defaults, data, options || {});

            opts.timeoutId = 0;
            opts.paused = opts.paused || false; // #57
            opts.container = container;
            opts._maxZ = opts.maxZ;

            opts.API = $.extend ( { _container: container }, $.fn.cycle.API );
            opts.API.log = log;
            opts.API.trigger = function( eventName, args ) {
                opts.container.trigger( eventName, args );
                return opts.API;
            };

            container.data( 'cycle.opts', opts );
            container.data( 'cycle.API', opts.API );

            // opportunity for plugins to modify opts and API
            opts.API.trigger('cycle-bootstrap', [ opts, opts.API ]);

            opts.API.addInitialSlides();
            opts.API.preInitSlideshow();

            if ( opts.slides.length )
                opts.API.initSlideshow();
        });
    };

    $.fn.cycle.API = {
        opts: function() {
            return this._container.data( 'cycle.opts' );
        },
        addInitialSlides: function() {
            var opts = this.opts();
            var slides = opts.slides;
            opts.slideCount = 0;
            opts.slides = $(); // empty set

            // add slides that already exist
            slides = slides.jquery ? slides : opts.container.find( slides );

            if ( opts.random ) {
                slides.sort(function() {return Math.random() - 0.5;});
            }

            opts.API.add( slides );
        },

        preInitSlideshow: function() {
            var opts = this.opts();
            opts.API.trigger('cycle-pre-initialize', [ opts ]);
            var tx = $.fn.cycle.transitions[opts.fx];
            if (tx && $.isFunction(tx.preInit))
                tx.preInit( opts );
            opts._preInitialized = true;
        },

        postInitSlideshow: function() {
            var opts = this.opts();
            opts.API.trigger('cycle-post-initialize', [ opts ]);
            var tx = $.fn.cycle.transitions[opts.fx];
            if (tx && $.isFunction(tx.postInit))
                tx.postInit( opts );
        },

        initSlideshow: function() {
            var opts = this.opts();
            var pauseObj = opts.container;
            var slideOpts;
            opts.API.calcFirstSlide();

            if ( opts.container.css('position') == 'static' )
                opts.container.css('position', 'relative');

            $(opts.slides[opts.currSlide]).css({
                opacity: 1,
                display: 'block',
                visibility: 'visible'
            });
            opts.API.stackSlides( opts.slides[opts.currSlide], opts.slides[opts.nextSlide], !opts.reverse );

            if ( opts.pauseOnHover ) {
                // allow pauseOnHover to specify an element
                if ( opts.pauseOnHover !== true )
                    pauseObj = $( opts.pauseOnHover );

                pauseObj.hover(
                    function(){ opts.API.pause( true ); },
                    function(){ opts.API.resume( true ); }
                );
            }

            // stage initial transition
            if ( opts.timeout ) {
                slideOpts = opts.API.getSlideOpts( opts.currSlide );
                opts.API.queueTransition( slideOpts, slideOpts.timeout + opts.delay );
            }

            opts._initialized = true;
            opts.API.updateView( true );
            opts.API.trigger('cycle-initialized', [ opts ]);
            opts.API.postInitSlideshow();
        },

        pause: function( hover ) {
            var opts = this.opts(),
                slideOpts = opts.API.getSlideOpts(),
                alreadyPaused = opts.hoverPaused || opts.paused;

            if ( hover )
                opts.hoverPaused = true;
            else
                opts.paused = true;

            if ( ! alreadyPaused ) {
                opts.container.addClass('cycle-paused');
                opts.API.trigger('cycle-paused', [ opts ]).log('cycle-paused');

                if ( slideOpts.timeout ) {
                    clearTimeout( opts.timeoutId );
                    opts.timeoutId = 0;

                    // determine how much time is left for the current slide
                    opts._remainingTimeout -= ( $.now() - opts._lastQueue );
                    if ( opts._remainingTimeout < 0 || isNaN(opts._remainingTimeout) )
                        opts._remainingTimeout = undefined;
                }
            }
        },

        resume: function( hover ) {
            var opts = this.opts(),
                alreadyResumed = !opts.hoverPaused && !opts.paused,
                remaining;

            if ( hover )
                opts.hoverPaused = false;
            else
                opts.paused = false;


            if ( ! alreadyResumed ) {
                opts.container.removeClass('cycle-paused');
                // #gh-230; if an animation is in progress then don't queue a new transition; it will
                // happen naturally
                if ( opts.slides.filter(':animated').length === 0 )
                    opts.API.queueTransition( opts.API.getSlideOpts(), opts._remainingTimeout );
                opts.API.trigger('cycle-resumed', [ opts, opts._remainingTimeout ] ).log('cycle-resumed');
            }
        },

        add: function( slides, prepend ) {
            var opts = this.opts();
            var oldSlideCount = opts.slideCount;
            var startSlideshow = false;
            var len;

            if ( $.type(slides) == 'string')
                slides = $.trim( slides );

            $( slides ).each(function(i) {
                var slideOpts;
                var slide = $(this);

                if ( prepend )
                    opts.container.prepend( slide );
                else
                    opts.container.append( slide );

                opts.slideCount++;
                slideOpts = opts.API.buildSlideOpts( slide );

                if ( prepend )
                    opts.slides = $( slide ).add( opts.slides );
                else
                    opts.slides = opts.slides.add( slide );

                opts.API.initSlide( slideOpts, slide, --opts._maxZ );

                slide.data('cycle.opts', slideOpts);
                opts.API.trigger('cycle-slide-added', [ opts, slideOpts, slide ]);
            });

            opts.API.updateView( true );

            startSlideshow = opts._preInitialized && (oldSlideCount < 2 && opts.slideCount >= 1);
            if ( startSlideshow ) {
                if ( !opts._initialized )
                    opts.API.initSlideshow();
                else if ( opts.timeout ) {
                    len = opts.slides.length;
                    opts.nextSlide = opts.reverse ? len - 1 : 1;
                    if ( !opts.timeoutId ) {
                        opts.API.queueTransition( opts );
                    }
                }
            }
        },

        calcFirstSlide: function() {
            var opts = this.opts();
            var firstSlideIndex;
            firstSlideIndex = parseInt( opts.startingSlide || 0, 10 );
            if (firstSlideIndex >= opts.slides.length || firstSlideIndex < 0)
                firstSlideIndex = 0;

            opts.currSlide = firstSlideIndex;
            if ( opts.reverse ) {
                opts.nextSlide = firstSlideIndex - 1;
                if (opts.nextSlide < 0)
                    opts.nextSlide = opts.slides.length - 1;
            }
            else {
                opts.nextSlide = firstSlideIndex + 1;
                if (opts.nextSlide == opts.slides.length)
                    opts.nextSlide = 0;
            }
        },

        calcNextSlide: function() {
            var opts = this.opts();
            var roll;
            if ( opts.reverse ) {
                roll = (opts.nextSlide - 1) < 0;
                opts.nextSlide = roll ? opts.slideCount - 1 : opts.nextSlide-1;
                opts.currSlide = roll ? 0 : opts.nextSlide+1;
            }
            else {
                roll = (opts.nextSlide + 1) == opts.slides.length;
                opts.nextSlide = roll ? 0 : opts.nextSlide+1;
                opts.currSlide = roll ? opts.slides.length-1 : opts.nextSlide-1;
            }
        },

        calcTx: function( slideOpts, manual ) {
            var opts = slideOpts;
            var tx;

            if ( opts._tempFx )
                tx = $.fn.cycle.transitions[opts._tempFx];
            else if ( manual && opts.manualFx )
                tx = $.fn.cycle.transitions[opts.manualFx];

            if ( !tx )
                tx = $.fn.cycle.transitions[opts.fx];

            opts._tempFx = null;
            this.opts()._tempFx = null;

            if (!tx) {
                tx = $.fn.cycle.transitions.fade;
                opts.API.log('Transition "' + opts.fx + '" not found.  Using fade.');
            }
            return tx;
        },

        prepareTx: function( manual, fwd ) {
            var opts = this.opts();
            var after, curr, next, slideOpts, tx;

            if ( opts.slideCount < 2 ) {
                opts.timeoutId = 0;
                return;
            }
            if ( manual && ( !opts.busy || opts.manualTrump ) ) {
                opts.API.stopTransition();
                opts.busy = false;
                clearTimeout(opts.timeoutId);
                opts.timeoutId = 0;
            }
            if ( opts.busy )
                return;
            if ( opts.timeoutId === 0 && !manual )
                return;

            curr = opts.slides[opts.currSlide];
            next = opts.slides[opts.nextSlide];
            slideOpts = opts.API.getSlideOpts( opts.nextSlide );
            tx = opts.API.calcTx( slideOpts, manual );

            opts._tx = tx;

            if ( manual && slideOpts.manualSpeed !== undefined )
                slideOpts.speed = slideOpts.manualSpeed;

            // if ( opts.nextSlide === opts.currSlide )
            //     opts.API.calcNextSlide();

            // ensure that:
            //      1. advancing to a different slide
            //      2. this is either a manual event (prev/next, pager, cmd) or
            //              a timer event and slideshow is not paused
            if ( opts.nextSlide != opts.currSlide &&
                (manual || (!opts.paused && !opts.hoverPaused && opts.timeout) )) { // #62

                opts.API.trigger('cycle-before', [ slideOpts, curr, next, fwd ]);
                if ( tx.before )
                    tx.before( slideOpts, curr, next, fwd );

                after = function() {
                    opts.busy = false;
                    // #76; bail if slideshow has been destroyed
                    if (! opts.container.data( 'cycle.opts' ) )
                        return;

                    if (tx.after)
                        tx.after( slideOpts, curr, next, fwd );
                    opts.API.trigger('cycle-after', [ slideOpts, curr, next, fwd ]);
                    opts.API.queueTransition( slideOpts);
                    opts.API.updateView( true );
                };

                opts.busy = true;
                if (tx.transition)
                    tx.transition(slideOpts, curr, next, fwd, after);
                else
                    opts.API.doTransition( slideOpts, curr, next, fwd, after);

                opts.API.calcNextSlide();
                opts.API.updateView();
            } else {
                opts.API.queueTransition( slideOpts );
            }
        },

        // perform the actual animation
        doTransition: function( slideOpts, currEl, nextEl, fwd, callback) {
            var opts = slideOpts;
            var curr = $(currEl), next = $(nextEl);
            var fn = function() {
                // make sure animIn has something so that callback doesn't trigger immediately
                next.animate(opts.animIn || { opacity: 1}, opts.speed, opts.easeIn || opts.easing, callback);
            };

            next.css(opts.cssBefore || {});
            curr.animate(opts.animOut || {}, opts.speed, opts.easeOut || opts.easing, function() {
                curr.css(opts.cssAfter || {});
                if (!opts.sync) {
                    fn();
                }
            });
            if (opts.sync) {
                fn();
            }
        },

        queueTransition: function( slideOpts, specificTimeout ) {
            var opts = this.opts();
            var timeout = specificTimeout !== undefined ? specificTimeout : slideOpts.timeout;
            if (opts.nextSlide === 0 && --opts.loop === 0) {
                opts.API.log('terminating; loop=0');
                opts.timeout = 0;
                if ( timeout ) {
                    setTimeout(function() {
                        opts.API.trigger('cycle-finished', [ opts ]);
                    }, timeout);
                }
                else {
                    opts.API.trigger('cycle-finished', [ opts ]);
                }
                // reset nextSlide
                opts.nextSlide = opts.currSlide;
                return;
            }
            if ( opts.continueAuto !== undefined ) {
                if ( opts.continueAuto === false ||
                    ($.isFunction(opts.continueAuto) && opts.continueAuto() === false )) {
                    opts.API.log('terminating automatic transitions');
                    opts.timeout = 0;
                    if ( opts.timeoutId )
                        clearTimeout(opts.timeoutId);
                    return;
                }
            }
            if ( timeout ) {
                opts._lastQueue = $.now();
                if ( specificTimeout === undefined )
                    opts._remainingTimeout = slideOpts.timeout;

                if ( !opts.paused && ! opts.hoverPaused ) {
                    opts.timeoutId = setTimeout(function() {
                        opts.API.prepareTx( false, !opts.reverse );
                    }, timeout );
                }
            }
        },

        stopTransition: function() {
            var opts = this.opts();
            if ( opts.slides.filter(':animated').length ) {
                opts.slides.stop(false, true);
                opts.API.trigger('cycle-transition-stopped', [ opts ]);
            }

            if ( opts._tx && opts._tx.stopTransition )
                opts._tx.stopTransition( opts );
        },

        // advance slide forward or back
        advanceSlide: function( val ) {
            var opts = this.opts();
            clearTimeout(opts.timeoutId);
            opts.timeoutId = 0;
            opts.nextSlide = opts.currSlide + val;

            if (opts.nextSlide < 0)
                opts.nextSlide = opts.slides.length - 1;
            else if (opts.nextSlide >= opts.slides.length)
                opts.nextSlide = 0;

            opts.API.prepareTx( true,  val >= 0 );
            return false;
        },

        buildSlideOpts: function( slide ) {
            var opts = this.opts();
            var val, shortName;
            var slideOpts = slide.data() || {};
            for (var p in slideOpts) {
                // allow props to be accessed sans 'cycle' prefix and log the overrides
                if (slideOpts.hasOwnProperty(p) && /^cycle[A-Z]+/.test(p) ) {
                    val = slideOpts[p];
                    shortName = p.match(/^cycle(.*)/)[1].replace(/^[A-Z]/, lowerCase);
                    opts.API.log('['+(opts.slideCount-1)+']', shortName+':', val, '('+typeof val +')');
                    slideOpts[shortName] = val;
                }
            }

            slideOpts = $.extend( {}, $.fn.cycle.defaults, opts, slideOpts );
            slideOpts.slideNum = opts.slideCount;

            try {
                // these props should always be read from the master state object
                delete slideOpts.API;
                delete slideOpts.slideCount;
                delete slideOpts.currSlide;
                delete slideOpts.nextSlide;
                delete slideOpts.slides;
            } catch(e) {
                // no op
            }
            return slideOpts;
        },

        getSlideOpts: function( index ) {
            var opts = this.opts();
            if ( index === undefined )
                index = opts.currSlide;

            var slide = opts.slides[index];
            var slideOpts = $(slide).data('cycle.opts');
            return $.extend( {}, opts, slideOpts );
        },

        initSlide: function( slideOpts, slide, suggestedZindex ) {
            var opts = this.opts();
            slide.css( slideOpts.slideCss || {} );
            if ( suggestedZindex > 0 )
                slide.css( 'zIndex', suggestedZindex );

            // ensure that speed settings are sane
            if ( isNaN( slideOpts.speed ) )
                slideOpts.speed = $.fx.speeds[slideOpts.speed] || $.fx.speeds._default;
            if ( !slideOpts.sync )
                slideOpts.speed = slideOpts.speed / 2;

            slide.addClass( opts.slideClass );
        },

        updateView: function( isAfter, isDuring, forceEvent ) {
            var opts = this.opts();
            if ( !opts._initialized )
                return;
            var slideOpts = opts.API.getSlideOpts();
            var currSlide = opts.slides[ opts.currSlide ];

            if ( ! isAfter && isDuring !== true ) {
                opts.API.trigger('cycle-update-view-before', [ opts, slideOpts, currSlide ]);
                if ( opts.updateView < 0 )
                    return;
            }

            if ( opts.slideActiveClass ) {
                opts.slides.removeClass( opts.slideActiveClass )
                    .eq( opts.currSlide ).addClass( opts.slideActiveClass );
            }

            if ( isAfter && opts.hideNonActive )
                opts.slides.filter( ':not(.' + opts.slideActiveClass + ')' ).css('visibility', 'hidden');

            if ( opts.updateView === 0 ) {
                setTimeout(function() {
                    opts.API.trigger('cycle-update-view', [ opts, slideOpts, currSlide, isAfter ]);
                }, slideOpts.speed / (opts.sync ? 2 : 1) );
            }

            if ( opts.updateView !== 0 )
                opts.API.trigger('cycle-update-view', [ opts, slideOpts, currSlide, isAfter ]);

            if ( isAfter )
                opts.API.trigger('cycle-update-view-after', [ opts, slideOpts, currSlide ]);
        },

        getComponent: function( name ) {
            var opts = this.opts();
            var selector = opts[name];
            if (typeof selector === 'string') {
                // if selector is a child, sibling combinator, adjancent selector then use find, otherwise query full dom
                return (/^\s*[\>|\+|~]/).test( selector ) ? opts.container.find( selector ) : $( selector );
            }
            if (selector.jquery)
                return selector;

            return $(selector);
        },

        stackSlides: function( curr, next, fwd ) {
            var opts = this.opts();
            if ( !curr ) {
                curr = opts.slides[opts.currSlide];
                next = opts.slides[opts.nextSlide];
                fwd = !opts.reverse;
            }

            // reset the zIndex for the common case:
            // curr slide on top,  next slide beneath, and the rest in order to be shown
            $(curr).css('zIndex', opts.maxZ);

            var i;
            var z = opts.maxZ - 2;
            var len = opts.slideCount;
            if (fwd) {
                for ( i = opts.currSlide + 1; i < len; i++ )
                    $( opts.slides[i] ).css( 'zIndex', z-- );
                for ( i = 0; i < opts.currSlide; i++ )
                    $( opts.slides[i] ).css( 'zIndex', z-- );
            }
            else {
                for ( i = opts.currSlide - 1; i >= 0; i-- )
                    $( opts.slides[i] ).css( 'zIndex', z-- );
                for ( i = len - 1; i > opts.currSlide; i-- )
                    $( opts.slides[i] ).css( 'zIndex', z-- );
            }

            $(next).css('zIndex', opts.maxZ - 1);
        },

        getSlideIndex: function( el ) {
            return this.opts().slides.index( el );
        }

    }; // API

// default logger
    $.fn.cycle.log = function log() {
        /*global console:true */
        if (window.console && console.log)
            console.log('[cycle2] ' + Array.prototype.join.call(arguments, ' ') );
    };

    $.fn.cycle.version = function() { return 'Cycle2: ' + version; };

// helper functions

    function lowerCase(s) {
        return (s || '').toLowerCase();
    }

// expose transition object
    $.fn.cycle.transitions = {
        custom: {
        },
        none: {
            before: function( opts, curr, next, fwd ) {
                opts.API.stackSlides( next, curr, fwd );
                opts.cssBefore = { opacity: 1, visibility: 'visible', display: 'block' };
            }
        },
        fade: {
            before: function( opts, curr, next, fwd ) {
                var css = opts.API.getSlideOpts( opts.nextSlide ).slideCss || {};
                opts.API.stackSlides( curr, next, fwd );
                opts.cssBefore = $.extend(css, { opacity: 0, visibility: 'visible', display: 'block' });
                opts.animIn = { opacity: 1 };
                opts.animOut = { opacity: 0 };
            }
        },
        fadeout: {
            before: function( opts , curr, next, fwd ) {
                var css = opts.API.getSlideOpts( opts.nextSlide ).slideCss || {};
                opts.API.stackSlides( curr, next, fwd );
                opts.cssBefore = $.extend(css, { opacity: 1, visibility: 'visible', display: 'block' });
                opts.animOut = { opacity: 0 };
            }
        },
        scrollHorz: {
            before: function( opts, curr, next, fwd ) {
                opts.API.stackSlides( curr, next, fwd );
                var w = opts.container.css('overflow','hidden').width();
                opts.cssBefore = { left: fwd ? w : - w, top: 0, opacity: 1, visibility: 'visible', display: 'block' };
                opts.cssAfter = { zIndex: opts._maxZ - 2, left: 0 };
                opts.animIn = { left: 0 };
                opts.animOut = { left: fwd ? -w : w };
            }
        }
    };

// @see: http://jquery.malsup.com/cycle2/api
    $.fn.cycle.defaults = {
        allowWrap:        true,
        autoSelector:     '.cycle-slideshow[data-cycle-auto-init!=false]',
        delay:            0,
        easing:           null,
        fx:              'fade',
        hideNonActive:    true,
        loop:             0,
        manualFx:         undefined,
        manualSpeed:      undefined,
        manualTrump:      true,
        maxZ:             100,
        pauseOnHover:     false,
        reverse:          false,
        slideActiveClass: 'cycle-slide-active',
        slideClass:       'cycle-slide',
        slideCss:         { position: 'absolute', top: 0, left: 0 },
        slides:          '> img',
        speed:            500,
        startingSlide:    0,
        sync:             true,
        timeout:          4000,
        updateView:       0
    };

// automatically find and run slideshows
    $(document).ready(function() {
        $( $.fn.cycle.defaults.autoSelector ).cycle();
    });

})(jQuery);

/*! Cycle2 autoheight plugin; Copyright (c) M.Alsup, 2012; version: 20130913 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        autoHeight: 0, // setting this option to false disables autoHeight logic
        autoHeightSpeed: 250,
        autoHeightEasing: null
    });

    $(document).on( 'cycle-initialized', function( e, opts ) {
        var autoHeight = opts.autoHeight;
        var t = $.type( autoHeight );
        var resizeThrottle = null;
        var ratio;

        if ( t !== 'string' && t !== 'number' )
            return;

        // bind events
        opts.container.on( 'cycle-slide-added cycle-slide-removed', initAutoHeight );
        opts.container.on( 'cycle-destroyed', onDestroy );

        if ( autoHeight == 'container' ) {
            opts.container.on( 'cycle-before', onBefore );
        }
        else if ( t === 'string' && /\d+\:\d+/.test( autoHeight ) ) {
            // use ratio
            ratio = autoHeight.match(/(\d+)\:(\d+)/);
            ratio = ratio[1] / ratio[2];
            opts._autoHeightRatio = ratio;
        }

        // if autoHeight is a number then we don't need to recalculate the sentinel
        // index on resize
        if ( t !== 'number' ) {
            // bind unique resize handler per slideshow (so it can be 'off-ed' in onDestroy)
            opts._autoHeightOnResize = function () {
                clearTimeout( resizeThrottle );
                resizeThrottle = setTimeout( onResize, 50 );
            };

            $(window).on( 'resize orientationchange', opts._autoHeightOnResize );
        }

        setTimeout( onResize, 30 );

        function onResize() {
            initAutoHeight( e, opts );
        }
    });

    function initAutoHeight( e, opts ) {
        var clone, height, sentinelIndex;
        var autoHeight = opts.autoHeight;

        if ( autoHeight == 'container' ) {
            height = $( opts.slides[ opts.currSlide ] ).outerHeight();
            opts.container.height( height );
        }
        else if ( opts._autoHeightRatio ) {
            opts.container.height( opts.container.width() / opts._autoHeightRatio );
        }
        else if ( autoHeight === 'calc' || ( $.type( autoHeight ) == 'number' && autoHeight >= 0 ) ) {
            if ( autoHeight === 'calc' )
                sentinelIndex = calcSentinelIndex( e, opts );
            else if ( autoHeight >= opts.slides.length )
                sentinelIndex = 0;
            else
                sentinelIndex = autoHeight;

            // only recreate sentinel if index is different
            if ( sentinelIndex == opts._sentinelIndex )
                return;

            opts._sentinelIndex = sentinelIndex;
            if ( opts._sentinel )
                opts._sentinel.remove();

            // clone existing slide as sentinel
            clone = $( opts.slides[ sentinelIndex ].cloneNode(true) );

            // #50; remove special attributes from cloned content
            clone.removeAttr( 'id name rel' ).find( '[id],[name],[rel]' ).removeAttr( 'id name rel' );

            clone.css({
                position: 'static',
                visibility: 'hidden',
                display: 'block'
            }).prependTo( opts.container ).addClass('cycle-sentinel cycle-slide').removeClass('cycle-slide-active');
            clone.find( '*' ).css( 'visibility', 'hidden' );

            opts._sentinel = clone;
        }
    }

    function calcSentinelIndex( e, opts ) {
        var index = 0, max = -1;

        // calculate tallest slide index
        opts.slides.each(function(i) {
            var h = $(this).height();
            if ( h > max ) {
                max = h;
                index = i;
            }
        });
        return index;
    }

    function onBefore( e, opts, outgoing, incoming, forward ) {
        var h = $(incoming).outerHeight();
        opts.container.animate( { height: h }, opts.autoHeightSpeed, opts.autoHeightEasing );
    }

    function onDestroy( e, opts ) {
        if ( opts._autoHeightOnResize ) {
            $(window).off( 'resize orientationchange', opts._autoHeightOnResize );
            opts._autoHeightOnResize = null;
        }
        opts.container.off( 'cycle-slide-added cycle-slide-removed', initAutoHeight );
        opts.container.off( 'cycle-destroyed', onDestroy );
        opts.container.off( 'cycle-before', onBefore );

        if ( opts._sentinel ) {
            opts._sentinel.remove();
            opts._sentinel = null;
        }
    }

})(jQuery);

/*! caption plugin for Cycle2;  version: 20130306 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        caption:          '> .cycle-caption',
        captionTemplate:  '{{slideNum}} / {{slideCount}}',
        overlay:          '> .cycle-overlay',
        overlayTemplate:  '<div>{{title}}</div><div>{{desc}}</div>',
        captionModule:    'caption'
    });

    $(document).on( 'cycle-update-view', function( e, opts, slideOpts, currSlide ) {
        if ( opts.captionModule !== 'caption' )
            return;
        var el;
        $.each(['caption','overlay'], function() {
            var name = this;
            var template = slideOpts[name+'Template'];
            var el = opts.API.getComponent( name );
            if( el.length && template ) {
                el.html( opts.API.tmpl( template, slideOpts, opts, currSlide ) );
                el.show();
            }
            else {
                el.hide();
            }
        });
    });

    $(document).on( 'cycle-destroyed', function( e, opts ) {
        var el;
        $.each(['caption','overlay'], function() {
            var name = this, template = opts[name+'Template'];
            if ( opts[name] && template ) {
                el = opts.API.getComponent( 'caption' );
                el.empty();
            }
        });
    });

})(jQuery);

/*! command plugin for Cycle2;  version: 20140415 */
(function($) {
    "use strict";

    var c2 = $.fn.cycle;

    $.fn.cycle = function( options ) {
        var cmd, cmdFn, opts;
        var args = $.makeArray( arguments );

        if ( $.type( options ) == 'number' ) {
            return this.cycle( 'goto', options );
        }

        if ( $.type( options ) == 'string' ) {
            return this.each(function() {
                var cmdArgs;
                cmd = options;
                opts = $(this).data('cycle.opts');

                if ( opts === undefined ) {
                    c2.log('slideshow must be initialized before sending commands; "' + cmd + '" ignored');
                    return;
                }
                else {
                    cmd = cmd == 'goto' ? 'jump' : cmd; // issue #3; change 'goto' to 'jump' internally
                    cmdFn = opts.API[ cmd ];
                    if ( $.isFunction( cmdFn )) {
                        cmdArgs = $.makeArray( args );
                        cmdArgs.shift();
                        return cmdFn.apply( opts.API, cmdArgs );
                    }
                    else {
                        c2.log( 'unknown command: ', cmd );
                    }
                }
            });
        }
        else {
            return c2.apply( this, arguments );
        }
    };

// copy props
    $.extend( $.fn.cycle, c2 );

    $.extend( c2.API, {
        next: function() {
            var opts = this.opts();
            if ( opts.busy && ! opts.manualTrump )
                return;

            var count = opts.reverse ? -1 : 1;
            if ( opts.allowWrap === false && ( opts.currSlide + count ) >= opts.slideCount )
                return;

            opts.API.advanceSlide( count );
            opts.API.trigger('cycle-next', [ opts ]).log('cycle-next');
        },

        prev: function() {
            var opts = this.opts();
            if ( opts.busy && ! opts.manualTrump )
                return;
            var count = opts.reverse ? 1 : -1;
            if ( opts.allowWrap === false && ( opts.currSlide + count ) < 0 )
                return;

            opts.API.advanceSlide( count );
            opts.API.trigger('cycle-prev', [ opts ]).log('cycle-prev');
        },

        destroy: function() {
            this.stop(); //#204

            var opts = this.opts();
            var clean = $.isFunction( $._data ) ? $._data : $.noop;  // hack for #184 and #201
            clearTimeout(opts.timeoutId);
            opts.timeoutId = 0;
            opts.API.stop();
            opts.API.trigger( 'cycle-destroyed', [ opts ] ).log('cycle-destroyed');
            opts.container.removeData();
            clean( opts.container[0], 'parsedAttrs', false );

            // #75; remove inline styles
            if ( ! opts.retainStylesOnDestroy ) {
                opts.container.removeAttr( 'style' );
                opts.slides.removeAttr( 'style' );
                opts.slides.removeClass( opts.slideActiveClass );
            }
            opts.slides.each(function() {
                var slide = $(this);
                slide.removeData();
                slide.removeClass( opts.slideClass );
                clean( this, 'parsedAttrs', false );
            });
        },

        jump: function( index, fx ) {
            // go to the requested slide
            var fwd;
            var opts = this.opts();
            if ( opts.busy && ! opts.manualTrump )
                return;
            var num = parseInt( index, 10 );
            if (isNaN(num) || num < 0 || num >= opts.slides.length) {
                opts.API.log('goto: invalid slide index: ' + num);
                return;
            }
            if (num == opts.currSlide) {
                opts.API.log('goto: skipping, already on slide', num);
                return;
            }
            opts.nextSlide = num;
            clearTimeout(opts.timeoutId);
            opts.timeoutId = 0;
            opts.API.log('goto: ', num, ' (zero-index)');
            fwd = opts.currSlide < opts.nextSlide;
            opts._tempFx = fx;
            opts.API.prepareTx( true, fwd );
        },

        stop: function() {
            var opts = this.opts();
            var pauseObj = opts.container;
            clearTimeout(opts.timeoutId);
            opts.timeoutId = 0;
            opts.API.stopTransition();
            if ( opts.pauseOnHover ) {
                if ( opts.pauseOnHover !== true )
                    pauseObj = $( opts.pauseOnHover );
                pauseObj.off('mouseenter mouseleave');
            }
            opts.API.trigger('cycle-stopped', [ opts ]).log('cycle-stopped');
        },

        reinit: function() {
            var opts = this.opts();
            opts.API.destroy();
            opts.container.cycle();
        },

        remove: function( index ) {
            var opts = this.opts();
            var slide, slideToRemove, slides = [], slideNum = 1;
            for ( var i=0; i < opts.slides.length; i++ ) {
                slide = opts.slides[i];
                if ( i == index ) {
                    slideToRemove = slide;
                }
                else {
                    slides.push( slide );
                    $( slide ).data('cycle.opts').slideNum = slideNum;
                    slideNum++;
                }
            }
            if ( slideToRemove ) {
                opts.slides = $( slides );
                opts.slideCount--;
                $( slideToRemove ).remove();
                if (index == opts.currSlide)
                    opts.API.advanceSlide( 1 );
                else if ( index < opts.currSlide )
                    opts.currSlide--;
                else
                    opts.currSlide++;

                opts.API.trigger('cycle-slide-removed', [ opts, index, slideToRemove ]).log('cycle-slide-removed');
                opts.API.updateView();
            }
        }

    });

// listen for clicks on elements with data-cycle-cmd attribute
    $(document).on('click.cycle', '[data-cycle-cmd]', function(e) {
        // issue cycle command
        e.preventDefault();
        var el = $(this);
        var command = el.data('cycle-cmd');
        var context = el.data('cycle-context') || '.cycle-slideshow';
        $(context).cycle(command, el.data('cycle-arg'));
    });


})(jQuery);

/*! hash plugin for Cycle2;  version: 20130905 */
(function($) {
    "use strict";

    $(document).on( 'cycle-pre-initialize', function( e, opts ) {
        onHashChange( opts, true );

        opts._onHashChange = function() {
            onHashChange( opts, false );
        };

        $( window ).on( 'hashchange', opts._onHashChange);
    });

    $(document).on( 'cycle-update-view', function( e, opts, slideOpts ) {
        if ( slideOpts.hash && ( '#' + slideOpts.hash ) != window.location.hash ) {
            opts._hashFence = true;
            window.location.hash = slideOpts.hash;
        }
    });

    $(document).on( 'cycle-destroyed', function( e, opts) {
        if ( opts._onHashChange ) {
            $( window ).off( 'hashchange', opts._onHashChange );
        }
    });

    function onHashChange( opts, setStartingSlide ) {
        var hash;
        if ( opts._hashFence ) {
            opts._hashFence = false;
            return;
        }

        hash = window.location.hash.substring(1);

        opts.slides.each(function(i) {
            if ( $(this).data( 'cycle-hash' ) == hash ) {
                if ( setStartingSlide === true ) {
                    opts.startingSlide = i;
                }
                else {
                    var fwd = opts.currSlide < i;
                    opts.nextSlide = i;
                    opts.API.prepareTx( true, fwd );
                }
                return false;
            }
        });
    }

})(jQuery);

/*! loader plugin for Cycle2;  version: 20131121 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        loader: false
    });

    $(document).on( 'cycle-bootstrap', function( e, opts ) {
        var addFn;

        if ( !opts.loader )
            return;

        // override API.add for this slideshow
        addFn = opts.API.add;
        opts.API.add = add;

        function add( slides, prepend ) {
            var slideArr = [];
            if ( $.type( slides ) == 'string' )
                slides = $.trim( slides );
            else if ( $.type( slides) === 'array' ) {
                for (var i=0; i < slides.length; i++ )
                    slides[i] = $(slides[i])[0];
            }

            slides = $( slides );
            var slideCount = slides.length;

            if ( ! slideCount )
                return;

            slides.css('visibility','hidden').appendTo('body').each(function(i) { // appendTo fixes #56
                var count = 0;
                var slide = $(this);
                var images = slide.is('img') ? slide : slide.find('img');
                slide.data('index', i);
                // allow some images to be marked as unimportant (and filter out images w/o src value)
                images = images.filter(':not(.cycle-loader-ignore)').filter(':not([src=""])');
                if ( ! images.length ) {
                    --slideCount;
                    slideArr.push( slide );
                    return;
                }

                count = images.length;
                images.each(function() {
                    // add images that are already loaded
                    if ( this.complete ) {
                        imageLoaded();
                    }
                    else {
                        $(this).load(function() {
                            imageLoaded();
                        }).on("error", function() {
                            if ( --count === 0 ) {
                                // ignore this slide
                                opts.API.log('slide skipped; img not loaded:', this.src);
                                if ( --slideCount === 0 && opts.loader == 'wait') {
                                    addFn.apply( opts.API, [ slideArr, prepend ] );
                                }
                            }
                        });
                    }
                });

                function imageLoaded() {
                    if ( --count === 0 ) {
                        --slideCount;
                        addSlide( slide );
                    }
                }
            });

            if ( slideCount )
                opts.container.addClass('cycle-loading');


            function addSlide( slide ) {
                var curr;
                if ( opts.loader == 'wait' ) {
                    slideArr.push( slide );
                    if ( slideCount === 0 ) {
                        // #59; sort slides into original markup order
                        slideArr.sort( sorter );
                        addFn.apply( opts.API, [ slideArr, prepend ] );
                        opts.container.removeClass('cycle-loading');
                    }
                }
                else {
                    curr = $(opts.slides[opts.currSlide]);
                    addFn.apply( opts.API, [ slide, prepend ] );
                    curr.show();
                    opts.container.removeClass('cycle-loading');
                }
            }

            function sorter(a, b) {
                return a.data('index') - b.data('index');
            }
        }
    });

})(jQuery);

/*! pager plugin for Cycle2;  version: 20140415 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        pager:            '> .cycle-pager',
        pagerActiveClass: 'cycle-pager-active',
        pagerEvent:       'click.cycle',
        pagerEventBubble: undefined,
        pagerTemplate:    '<span>&bull;</span>'
    });

    $(document).on( 'cycle-bootstrap', function( e, opts, API ) {
        // add method to API
        API.buildPagerLink = buildPagerLink;
    });

    $(document).on( 'cycle-slide-added', function( e, opts, slideOpts, slideAdded ) {
        if ( opts.pager ) {
            opts.API.buildPagerLink ( opts, slideOpts, slideAdded );
            opts.API.page = page;
        }
    });

    $(document).on( 'cycle-slide-removed', function( e, opts, index, slideRemoved ) {
        if ( opts.pager ) {
            var pagers = opts.API.getComponent( 'pager' );
            pagers.each(function() {
                var pager = $(this);
                $( pager.children()[index] ).remove();
            });
        }
    });

    $(document).on( 'cycle-update-view', function( e, opts, slideOpts ) {
        var pagers;

        if ( opts.pager ) {
            pagers = opts.API.getComponent( 'pager' );
            pagers.each(function() {
                $(this).children().removeClass( opts.pagerActiveClass )
                    .eq( opts.currSlide ).addClass( opts.pagerActiveClass );
            });
        }
    });

    $(document).on( 'cycle-destroyed', function( e, opts ) {
        var pager = opts.API.getComponent( 'pager' );

        if ( pager ) {
            pager.children().off( opts.pagerEvent ); // #202
            if ( opts.pagerTemplate )
                pager.empty();
        }
    });

    function buildPagerLink( opts, slideOpts, slide ) {
        var pagerLink;
        var pagers = opts.API.getComponent( 'pager' );
        pagers.each(function() {
            var pager = $(this);
            if ( slideOpts.pagerTemplate ) {
                var markup = opts.API.tmpl( slideOpts.pagerTemplate, slideOpts, opts, slide[0] );
                pagerLink = $( markup ).appendTo( pager );
            }
            else {
                pagerLink = pager.children().eq( opts.slideCount - 1 );
            }
            pagerLink.on( opts.pagerEvent, function(e) {
                if ( ! opts.pagerEventBubble )
                    e.preventDefault();
                opts.API.page( pager, e.currentTarget);
            });
        });
    }

    function page( pager, target ) {
        /*jshint validthis:true */
        var opts = this.opts();
        if ( opts.busy && ! opts.manualTrump )
            return;

        var index = pager.children().index( target );
        var nextSlide = index;
        var fwd = opts.currSlide < nextSlide;
        if (opts.currSlide == nextSlide) {
            return; // no op, clicked pager for the currently displayed slide
        }
        opts.nextSlide = nextSlide;
        opts._tempFx = opts.pagerFx;
        opts.API.prepareTx( true, fwd );
        opts.API.trigger('cycle-pager-activated', [opts, pager, target ]);
    }

})(jQuery);

/*! prevnext plugin for Cycle2;  version: 20140408 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        next:           '> .cycle-next',
        nextEvent:      'click.cycle',
        disabledClass:  'disabled',
        prev:           '> .cycle-prev',
        prevEvent:      'click.cycle',
        swipe:          false
    });

    $(document).on( 'cycle-initialized', function( e, opts ) {
        opts.API.getComponent( 'next' ).on( opts.nextEvent, function(e) {
            e.preventDefault();
            opts.API.next();
        });

        opts.API.getComponent( 'prev' ).on( opts.prevEvent, function(e) {
            e.preventDefault();
            opts.API.prev();
        });

        if ( opts.swipe ) {
            var nextEvent = opts.swipeVert ? 'swipeUp.cycle' : 'swipeLeft.cycle swipeleft.cycle';
            var prevEvent = opts.swipeVert ? 'swipeDown.cycle' : 'swipeRight.cycle swiperight.cycle';
            opts.container.on( nextEvent, function(e) {
                opts._tempFx = opts.swipeFx;
                opts.API.next();
            });
            opts.container.on( prevEvent, function() {
                opts._tempFx = opts.swipeFx;
                opts.API.prev();
            });
        }
    });

    $(document).on( 'cycle-update-view', function( e, opts, slideOpts, currSlide ) {
        if ( opts.allowWrap )
            return;

        var cls = opts.disabledClass;
        var next = opts.API.getComponent( 'next' );
        var prev = opts.API.getComponent( 'prev' );
        var prevBoundry = opts._prevBoundry || 0;
        var nextBoundry = (opts._nextBoundry !== undefined)?opts._nextBoundry:opts.slideCount - 1;

        if ( opts.currSlide == nextBoundry )
            next.addClass( cls ).prop( 'disabled', true );
        else
            next.removeClass( cls ).prop( 'disabled', false );

        if ( opts.currSlide === prevBoundry )
            prev.addClass( cls ).prop( 'disabled', true );
        else
            prev.removeClass( cls ).prop( 'disabled', false );
    });


    $(document).on( 'cycle-destroyed', function( e, opts ) {
        opts.API.getComponent( 'prev' ).off( opts.nextEvent );
        opts.API.getComponent( 'next' ).off( opts.prevEvent );
        opts.container.off( 'swipeleft.cycle swiperight.cycle swipeLeft.cycle swipeRight.cycle swipeUp.cycle swipeDown.cycle' );
    });

})(jQuery);

/*! progressive loader plugin for Cycle2;  version: 20130315 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        progressive: false
    });

    $(document).on( 'cycle-pre-initialize', function( e, opts ) {
        if ( !opts.progressive )
            return;

        var API = opts.API;
        var nextFn = API.next;
        var prevFn = API.prev;
        var prepareTxFn = API.prepareTx;
        var type = $.type( opts.progressive );
        var slides, scriptEl;

        if ( type == 'array' ) {
            slides = opts.progressive;
        }
        else if ($.isFunction( opts.progressive ) ) {
            slides = opts.progressive( opts );
        }
        else if ( type == 'string' ) {
            scriptEl = $( opts.progressive );
            slides = $.trim( scriptEl.html() );
            if ( !slides )
                return;
            // is it json array?
            if ( /^(\[)/.test( slides ) ) {
                try {
                    slides = $.parseJSON( slides );
                }
                catch(err) {
                    API.log( 'error parsing progressive slides', err );
                    return;
                }
            }
            else {
                // plain text, split on delimeter
                slides = slides.split( new RegExp( scriptEl.data('cycle-split') || '\n') );

                // #95; look for empty slide
                if ( ! slides[ slides.length - 1 ] )
                    slides.pop();
            }
        }



        if ( prepareTxFn ) {
            API.prepareTx = function( manual, fwd ) {
                var index, slide;

                if ( manual || slides.length === 0 ) {
                    prepareTxFn.apply( opts.API, [ manual, fwd ] );
                    return;
                }

                if ( fwd && opts.currSlide == ( opts.slideCount-1) ) {
                    slide = slides[ 0 ];
                    slides = slides.slice( 1 );
                    opts.container.one('cycle-slide-added', function(e, opts ) {
                        setTimeout(function() {
                            opts.API.advanceSlide( 1 );
                        },50);
                    });
                    opts.API.add( slide );
                }
                else if ( !fwd && opts.currSlide === 0 ) {
                    index = slides.length-1;
                    slide = slides[ index ];
                    slides = slides.slice( 0, index );
                    opts.container.one('cycle-slide-added', function(e, opts ) {
                        setTimeout(function() {
                            opts.currSlide = 1;
                            opts.API.advanceSlide( -1 );
                        },50);
                    });
                    opts.API.add( slide, true );
                }
                else {
                    prepareTxFn.apply( opts.API, [ manual, fwd ] );
                }
            };
        }

        if ( nextFn ) {
            API.next = function() {
                var opts = this.opts();
                if ( slides.length && opts.currSlide == ( opts.slideCount - 1 ) ) {
                    var slide = slides[ 0 ];
                    slides = slides.slice( 1 );
                    opts.container.one('cycle-slide-added', function(e, opts ) {
                        nextFn.apply( opts.API );
                        opts.container.removeClass('cycle-loading');
                    });
                    opts.container.addClass('cycle-loading');
                    opts.API.add( slide );
                }
                else {
                    nextFn.apply( opts.API );
                }
            };
        }

        if ( prevFn ) {
            API.prev = function() {
                var opts = this.opts();
                if ( slides.length && opts.currSlide === 0 ) {
                    var index = slides.length-1;
                    var slide = slides[ index ];
                    slides = slides.slice( 0, index );
                    opts.container.one('cycle-slide-added', function(e, opts ) {
                        opts.currSlide = 1;
                        opts.API.advanceSlide( -1 );
                        opts.container.removeClass('cycle-loading');
                    });
                    opts.container.addClass('cycle-loading');
                    opts.API.add( slide, true );
                }
                else {
                    prevFn.apply( opts.API );
                }
            };
        }
    });

})(jQuery);

/*! tmpl plugin for Cycle2;  version: 20121227 */
(function($) {
    "use strict";

    $.extend($.fn.cycle.defaults, {
        tmplRegex: '{{((.)?.*?)}}'
    });

    $.extend($.fn.cycle.API, {
        tmpl: function( str, opts /*, ... */) {
            var regex = new RegExp( opts.tmplRegex || $.fn.cycle.defaults.tmplRegex, 'g' );
            var args = $.makeArray( arguments );
            args.shift();
            return str.replace(regex, function(_, str) {
                var i, j, obj, prop, names = str.split('.');
                for (i=0; i < args.length; i++) {
                    obj = args[i];
                    if ( ! obj )
                        continue;
                    if (names.length > 1) {
                        prop = obj;
                        for (j=0; j < names.length; j++) {
                            obj = prop;
                            prop = prop[ names[j] ] || str;
                        }
                    } else {
                        prop = obj[str];
                    }

                    if ($.isFunction(prop))
                        return prop.apply(obj, args);
                    if (prop !== undefined && prop !== null && prop != str)
                        return prop;
                }
                return str;
            });
        }
    });

})(jQuery);
},{}],8:[function(require,module,exports){
/*! scrollVert transition plugin for Cycle2;  version: 20140128 */
(function($) {
    "use strict";

    $.fn.cycle.transitions.scrollVert = {
        before: function( opts, curr, next, fwd ) {
            opts.API.stackSlides( opts, curr, next, fwd );
            var height = opts.container.css('overflow','hidden').height();
            opts.cssBefore = { top: fwd ? -height : height, left: 0, opacity: 1, display: 'block', visibility: 'visible' };
            opts.animIn = { top: 0 };
            opts.animOut = { top: fwd ? height : -height };
        }
    };

})(jQuery);
},{}],9:[function(require,module,exports){
/*! swipe plugin for Cycle2;  version: 20121120 */
(function($) {
    "use strict";

// this script adds support for touch events.  the logic is lifted from jQuery Mobile.
// if you have jQuery Mobile installed, you do NOT need this script

    var supportTouch = 'ontouchend' in document;

    $.event.special.swipe = $.event.special.swipe || {
            scrollSupressionThreshold: 10,   // More than this horizontal displacement, and we will suppress scrolling.
            durationThreshold: 1000,         // More time than this, and it isn't a swipe.
            horizontalDistanceThreshold: 30, // Swipe horizontal displacement must be more than this.
            verticalDistanceThreshold: 75,   // Swipe vertical displacement must be less than this.

            setup: function() {
                var $this = $( this );

                $this.bind( 'touchstart', function( event ) {
                    var data = event.originalEvent.touches ? event.originalEvent.touches[ 0 ] : event;
                    var stop, start = {
                        time: ( new Date() ).getTime(),
                        coords: [ data.pageX, data.pageY ],
                        origin: $( event.target )
                    };

                    function moveHandler( event ) {
                        if ( !start )
                            return;

                        var data = event.originalEvent.touches ? event.originalEvent.touches[ 0 ] : event;

                        stop = {
                            time: ( new Date() ).getTime(),
                            coords: [ data.pageX, data.pageY ]
                        };

                        // prevent scrolling
                        if ( Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.scrollSupressionThreshold ) {
                            event.preventDefault();
                        }
                    }

                    $this.bind( 'touchmove', moveHandler )
                        .one( 'touchend', function( event ) {
                            $this.unbind( 'touchmove', moveHandler );

                            if ( start && stop ) {
                                if ( stop.time - start.time < $.event.special.swipe.durationThreshold &&
                                    Math.abs( start.coords[ 0 ] - stop.coords[ 0 ] ) > $.event.special.swipe.horizontalDistanceThreshold &&
                                    Math.abs( start.coords[ 1 ] - stop.coords[ 1 ] ) < $.event.special.swipe.verticalDistanceThreshold ) {

                                    start.origin.trigger( "swipe" )
                                        .trigger( start.coords[0] > stop.coords[ 0 ] ? "swipeleft" : "swiperight" );
                                }
                            }
                            start = stop = undefined;
                        });
                });
            }
        };

    $.event.special.swipeleft = $.event.special.swipeleft || {
            setup: function() {
                $( this ).bind( 'swipe', $.noop );
            }
        };
    $.event.special.swiperight = $.event.special.swiperight || $.event.special.swipeleft;

})(jQuery);
},{}],10:[function(require,module,exports){
/*! tile transition plugin for Cycle2;  version: 20140128 */
(function ($) {
    "use strict";

    $.fn.cycle.transitions.tileSlide =
        $.fn.cycle.transitions.tileBlind = {

            before: function( opts, curr, next, fwd ) {
                opts.API.stackSlides( curr, next, fwd );
                $(curr).css({
                    display: 'block',
                    visibility: 'visible'
                });
                opts.container.css('overflow', 'hidden');
                // set defaults
                opts.tileDelay = opts.tileDelay || opts.fx == 'tileSlide' ? 100 : 125;
                opts.tileCount = opts.tileCount || 7;
                opts.tileVertical = opts.tileVertical !== false;

                if (!opts.container.data('cycleTileInitialized')) {
                    opts.container.on('cycle-destroyed', $.proxy(this.onDestroy, opts.API));
                    opts.container.data('cycleTileInitialized', true);
                }
            },

            transition: function( opts, curr, next, fwd, callback ) {
                opts.slides.not(curr).not(next).css('visibility','hidden');

                var tiles = $();
                var $curr = $(curr), $next = $(next);
                var tile, tileWidth, tileHeight, lastTileWidth, lastTileHeight,
                    num = opts.tileCount,
                    vert = opts.tileVertical,
                    height = opts.container.height(),
                    width = opts.container.width();

                if ( vert ) {
                    tileWidth = Math.floor(width / num);
                    lastTileWidth = width - (tileWidth * (num - 1));
                    tileHeight = lastTileHeight = height;
                }
                else {
                    tileWidth = lastTileWidth = width;
                    tileHeight = Math.floor(height / num);
                    lastTileHeight = height - (tileHeight * (num - 1));
                }

                // opts.speed = opts.speed / 2;
                opts.container.find('.cycle-tiles-container').remove();

                var animCSS;
                var tileCSS = { left: 0, top: 0, overflow: 'hidden', position: 'absolute', margin: 0, padding: 0 };
                if ( vert ) {
                    animCSS = opts.fx == 'tileSlide' ? { top: height } : { width: 0 };
                }
                else {
                    animCSS = opts.fx == 'tileSlide' ? { left: width } : { height: 0 };
                }

                var tilesContainer = $('<div class="cycle-tiles-container"></div>');
                tilesContainer.css({
                    zIndex: $curr.css('z-index'),
                    overflow: 'visible',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    direction: 'ltr' // #250
                });
                tilesContainer.insertBefore( next );

                for (var i = 0; i < num; i++) {
                    tile = $('<div></div>')
                        .css( tileCSS )
                        .css({
                            width:  ((num - 1 === i) ? lastTileWidth  : tileWidth),
                            height: ((num - 1 === i) ? lastTileHeight : tileHeight),
                            marginLeft: vert ? ((i * tileWidth)) : 0,
                            marginTop:  vert ? 0 : (i * tileHeight)
                        })
                        .append($curr.clone().css({
                            position: 'relative',
                            maxWidth: 'none',
                            width: $curr.width(),
                            margin: 0, padding: 0,
                            marginLeft: vert ? -(i * tileWidth) : 0,
                            marginTop: vert ? 0 : -(i * tileHeight)
                        }));
                    tiles = tiles.add(tile);
                }

                tilesContainer.append(tiles);
                $curr.css('visibility','hidden');
                $next.css({
                    opacity: 1,
                    display: 'block',
                    visibility: 'visible'
                });
                animateTile(fwd ? 0 : num - 1);

                opts._tileAniCallback = function() {
                    $next.css({
                        display: 'block',
                        visibility: 'visible'
                    });
                    $curr.css('visibility','hidden');
                    tilesContainer.remove();
                    callback();
                };

                function animateTile(i) {
                    tiles.eq(i).animate( animCSS, {
                        duration: opts.speed,
                        easing: opts.easing,
                        complete: function () {
                            if (fwd ? (num - 1 === i) : (0 === i)) {
                                opts._tileAniCallback();
                            }
                        }
                    });

                    setTimeout(function () {
                        if (fwd ? (num - 1 !== i) : (0 !== i)) {
                            animateTile(fwd ? (i + 1) : (i - 1));
                        }
                    }, opts.tileDelay);
                }
            },

            // tx API impl
            stopTransition: function( opts ) {
                opts.container.find('*').stop( true, true );
                if (opts._tileAniCallback)
                    opts._tileAniCallback();
            },

            // core API supplement
            onDestroy: function( e ) {
                var opts = this.opts();
                opts.container.find('.cycle-tiles-container').remove();
            }
        };

})(jQuery);
},{}],11:[function(require,module,exports){
/**
 * https://github.com/fatlinesofcode/jquery.smoothwheel
 * Using pull request found here for support for $(window):
 * https://github.com/mirikle/jquery.smoothwheel/blob/0b7dd07751387c5d4aaec9259b117a2e5e226abf/src/jquery.smoothwheel.js
 *
 * Edited script to remove unused variables & function
 * */

(function($) {

    var container, running = false,
        currentY = 0,
        targetY = 0,
        oldY = 0,
        maxScrollTop = 0,
        minScrollTop, direction, onRenderCallback = null,
        fricton = 0.95, // higher value for slower deceleration
        vy = 0,
        stepAmt = 1,
        minMovement = 0.1;

    var updateScrollTarget = function(amt) {
        targetY += amt;
        vy += (targetY - oldY) * stepAmt;

        oldY = targetY;
    }
    var render = function() {
        if (vy < -(minMovement) || vy > minMovement) {

            currentY = (currentY + vy);
            if (currentY > maxScrollTop) {
                currentY = vy = 0;
            } else if (currentY < minScrollTop) {
                vy = 0;
                currentY = minScrollTop;
            }

            container.scrollTop(-currentY);

            vy *= fricton;

            if (onRenderCallback) {
                onRenderCallback();
            }
        }
    }
    var animateLoop = function() {
        if (!running) return;
        requestAnimFrame(animateLoop);
        render();
        //log("45","animateLoop","animateLoop", "",stop);
    }
    var onWheel = function(e) {
        e.preventDefault();
        var evt = e.originalEvent;

        var delta = evt.detail ? evt.detail * -1 : evt.wheelDelta / 40;
        var dir = delta < 0 ? -1 : 1;
        if (dir != direction) {
            vy = 0;
            direction = dir;
        }

        //reset currentY in case non-wheel scroll has occurred (scrollbar drag, etc.)
        currentY = -container.scrollTop();
        updateScrollTarget(delta);
    }

    /*
     * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
     */
    window.requestAnimFrame = (function() {
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(callback) {
                window.setTimeout(callback, 1000 / 60);
            };
    })();


    $.fn.smoothWheel = function() {
        //  var args = [].splice.call(arguments, 0);
        var options = jQuery.extend({}, arguments[0]);
        return this.each(function(index, elm) {

            if (!('ontouchstart' in window)) {
                container = $(this);
                container.bind("mousewheel", onWheel);
                container.bind("DOMMouseScroll", onWheel);

                //set target/old/current Y to match current scroll position to prevent jump to top of container
                targetY = oldY = container.scrollTop();
                currentY = -targetY;

                minScrollTop = container.get(0).clientHeight - container.get(0).scrollHeight;
                if (options.onRender) {
                    onRenderCallback = options.onRender;
                }
                if (options.remove) {
                    log("122", "smoothWheel", "remove", "");
                    running = false;
                    container.unbind("mousewheel", onWheel);
                    container.unbind("DOMMouseScroll", onWheel);
                } else if (!running) {
                    running = true;
                    animateLoop();
                }

            }
        });
    };


})(jQuery);

},{}],12:[function(require,module,exports){
(function ($) {

    $.fn.parallax = function () {
        var window_width = $(window).width();
        var selector = ".builder-bg-image-slideshow, .builder-bg-image-wrap, .builder-video-bg";

        // Parallax Scripts
        return this.each(function(i) {
            var $this = $(this);
            $this.addClass('parallax');

            function updateParallax(initial) {
                var container_height;
                if (window_width < 601) {
                    container_height = ($this.height() > 0) ? $this.height() : $this.children(selector).height();
                }
                else {
                    container_height = ($this.height() > 0) ? $this.height() : 500;
                }
                var $img = $this.children(selector).first();
                var img_height = $img.height();
                var parallax_dist = img_height - container_height;
                var bottom = $this.offset().top + container_height;
                var top = $this.offset().top;
                var scrollTop = $(window).scrollTop();
                var windowHeight = window.innerHeight;
                var windowBottom = scrollTop + windowHeight;
                var percentScrolled = (windowBottom - top) / (container_height + windowHeight);
                var parallax = Math.round((parallax_dist * percentScrolled));

                if (initial) {
                    $img.css('display', 'block');
                }
                if ((bottom > scrollTop) && (top < (scrollTop + windowHeight))) {
                    $img.css('transform', "translate3D(-50%," + parallax + "px, 0)");
                }

            }

            // Wait for image load
            $this.find("img").one("load", function() {
                updateParallax(true);
            }).each(function() {
                if (this.complete) $(this).trigger("load");
            });

            $(window).scroll(function() {
                window_width = $(window).width();
                updateParallax(false);
            });

            $(window).resize(function() {
                window_width = $(window).width();
                updateParallax(false);
            });

        });

    };
}( jQuery ));

},{}],13:[function(require,module,exports){
(function() {
  'use strict'

  var $ = window.jQuery
  var Waypoint = window.Waypoint

  function JQueryAdapter(element) {
    this.$element = $(element)
  }

  $.each([
    'innerHeight',
    'innerWidth',
    'off',
    'offset',
    'on',
    'outerHeight',
    'outerWidth',
    'scrollLeft',
    'scrollTop'
  ], function(i, method) {
    JQueryAdapter.prototype[method] = function() {
      var args = Array.prototype.slice.call(arguments)
      return this.$element[method].apply(this.$element, args)
    }
  })

  $.each([
    'extend',
    'inArray',
    'isEmptyObject'
  ], function(i, method) {
    JQueryAdapter[method] = $[method]
  })

  Waypoint.adapters.push({
    name: 'jquery',
    Adapter: JQueryAdapter
  })
  Waypoint.Adapter = JQueryAdapter
}())

},{}],14:[function(require,module,exports){
(function() {
  'use strict'

  function requestAnimationFrameShim(callback) {
    window.setTimeout(callback, 1000 / 60)
  }

  var keyCounter = 0
  var contexts = {}
  var Waypoint = window.Waypoint
  var oldWindowLoad = window.onload

  /* http://imakewebthings.com/waypoints/api/context */
  function Context(element) {
    this.element = element
    this.Adapter = Waypoint.Adapter
    this.adapter = new this.Adapter(element)
    this.key = 'waypoint-context-' + keyCounter
    this.didScroll = false
    this.didResize = false
    this.oldScroll = {
      x: this.adapter.scrollLeft(),
      y: this.adapter.scrollTop()
    }
    this.waypoints = {
      vertical: {},
      horizontal: {}
    }

    element.waypointContextKey = this.key
    contexts[element.waypointContextKey] = this
    keyCounter += 1
    if (!Waypoint.windowContext) {
      Waypoint.windowContext = true
      Waypoint.windowContext = new Context(window)
    }

    this.createThrottledScrollHandler()
    this.createThrottledResizeHandler()
  }

  /* Private */
  Context.prototype.add = function(waypoint) {
    var axis = waypoint.options.horizontal ? 'horizontal' : 'vertical'
    this.waypoints[axis][waypoint.key] = waypoint
    this.refresh()
  }

  /* Private */
  Context.prototype.checkEmpty = function() {
    var horizontalEmpty = this.Adapter.isEmptyObject(this.waypoints.horizontal)
    var verticalEmpty = this.Adapter.isEmptyObject(this.waypoints.vertical)
    var isWindow = this.element == this.element.window
    if (horizontalEmpty && verticalEmpty && !isWindow) {
      this.adapter.off('.waypoints')
      delete contexts[this.key]
    }
  }

  /* Private */
  Context.prototype.createThrottledResizeHandler = function() {
    var self = this

    function resizeHandler() {
      self.handleResize()
      self.didResize = false
    }

    this.adapter.on('resize.waypoints', function() {
      if (!self.didResize) {
        self.didResize = true
        Waypoint.requestAnimationFrame(resizeHandler)
      }
    })
  }

  /* Private */
  Context.prototype.createThrottledScrollHandler = function() {
    var self = this
    function scrollHandler() {
      self.handleScroll()
      self.didScroll = false
    }

    this.adapter.on('scroll.waypoints', function() {
      if (!self.didScroll || Waypoint.isTouch) {
        self.didScroll = true
        Waypoint.requestAnimationFrame(scrollHandler)
      }
    })
  }

  /* Private */
  Context.prototype.handleResize = function() {
    Waypoint.Context.refreshAll()
  }

  /* Private */
  Context.prototype.handleScroll = function() {
    var triggeredGroups = {}
    var axes = {
      horizontal: {
        newScroll: this.adapter.scrollLeft(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left'
      },
      vertical: {
        newScroll: this.adapter.scrollTop(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      var isForward = axis.newScroll > axis.oldScroll
      var direction = isForward ? axis.forward : axis.backward

      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        if (waypoint.triggerPoint === null) {
          continue
        }
        var wasBeforeTriggerPoint = axis.oldScroll < waypoint.triggerPoint
        var nowAfterTriggerPoint = axis.newScroll >= waypoint.triggerPoint
        var crossedForward = wasBeforeTriggerPoint && nowAfterTriggerPoint
        var crossedBackward = !wasBeforeTriggerPoint && !nowAfterTriggerPoint
        if (crossedForward || crossedBackward) {
          waypoint.queueTrigger(direction)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    for (var groupKey in triggeredGroups) {
      triggeredGroups[groupKey].flushTriggers()
    }

    this.oldScroll = {
      x: axes.horizontal.newScroll,
      y: axes.vertical.newScroll
    }
  }

  /* Private */
  Context.prototype.innerHeight = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportHeight()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerHeight()
  }

  /* Private */
  Context.prototype.remove = function(waypoint) {
    delete this.waypoints[waypoint.axis][waypoint.key]
    this.checkEmpty()
  }

  /* Private */
  Context.prototype.innerWidth = function() {
    /*eslint-disable eqeqeq */
    if (this.element == this.element.window) {
      return Waypoint.viewportWidth()
    }
    /*eslint-enable eqeqeq */
    return this.adapter.innerWidth()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-destroy */
  Context.prototype.destroy = function() {
    var allWaypoints = []
    for (var axis in this.waypoints) {
      for (var waypointKey in this.waypoints[axis]) {
        allWaypoints.push(this.waypoints[axis][waypointKey])
      }
    }
    for (var i = 0, end = allWaypoints.length; i < end; i++) {
      allWaypoints[i].destroy()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-refresh */
  Context.prototype.refresh = function() {
    /*eslint-disable eqeqeq */
    var isWindow = this.element == this.element.window
    /*eslint-enable eqeqeq */
    var contextOffset = isWindow ? undefined : this.adapter.offset()
    var triggeredGroups = {}
    var axes

    this.handleScroll()
    axes = {
      horizontal: {
        contextOffset: isWindow ? 0 : contextOffset.left,
        contextScroll: isWindow ? 0 : this.oldScroll.x,
        contextDimension: this.innerWidth(),
        oldScroll: this.oldScroll.x,
        forward: 'right',
        backward: 'left',
        offsetProp: 'left'
      },
      vertical: {
        contextOffset: isWindow ? 0 : contextOffset.top,
        contextScroll: isWindow ? 0 : this.oldScroll.y,
        contextDimension: this.innerHeight(),
        oldScroll: this.oldScroll.y,
        forward: 'down',
        backward: 'up',
        offsetProp: 'top'
      }
    }

    for (var axisKey in axes) {
      var axis = axes[axisKey]
      for (var waypointKey in this.waypoints[axisKey]) {
        var waypoint = this.waypoints[axisKey][waypointKey]
        var adjustment = waypoint.options.offset
        var oldTriggerPoint = waypoint.triggerPoint
        var elementOffset = 0
        var freshWaypoint = oldTriggerPoint == null
        var contextModifier, wasBeforeScroll, nowAfterScroll
        var triggeredBackward, triggeredForward

        if (waypoint.element !== waypoint.element.window) {
          elementOffset = waypoint.adapter.offset()[axis.offsetProp]
        }

        if (typeof adjustment === 'function') {
          adjustment = adjustment.apply(waypoint)
        }
        else if (typeof adjustment === 'string') {
          adjustment = parseFloat(adjustment)
          if (waypoint.options.offset.indexOf('%') > - 1) {
            adjustment = Math.ceil(axis.contextDimension * adjustment / 100)
          }
        }

        contextModifier = axis.contextScroll - axis.contextOffset
        waypoint.triggerPoint = Math.floor(elementOffset + contextModifier - adjustment)
        wasBeforeScroll = oldTriggerPoint < axis.oldScroll
        nowAfterScroll = waypoint.triggerPoint >= axis.oldScroll
        triggeredBackward = wasBeforeScroll && nowAfterScroll
        triggeredForward = !wasBeforeScroll && !nowAfterScroll

        if (!freshWaypoint && triggeredBackward) {
          waypoint.queueTrigger(axis.backward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (!freshWaypoint && triggeredForward) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
        else if (freshWaypoint && axis.oldScroll >= waypoint.triggerPoint) {
          waypoint.queueTrigger(axis.forward)
          triggeredGroups[waypoint.group.id] = waypoint.group
        }
      }
    }

    Waypoint.requestAnimationFrame(function() {
      for (var groupKey in triggeredGroups) {
        triggeredGroups[groupKey].flushTriggers()
      }
    })

    return this
  }

  /* Private */
  Context.findOrCreateByElement = function(element) {
    return Context.findByElement(element) || new Context(element)
  }

  /* Private */
  Context.refreshAll = function() {
    for (var contextId in contexts) {
      contexts[contextId].refresh()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/context-find-by-element */
  Context.findByElement = function(element) {
    return contexts[element.waypointContextKey]
  }

  window.onload = function() {
    if (oldWindowLoad) {
      oldWindowLoad()
    }
    Context.refreshAll()
  }


  Waypoint.requestAnimationFrame = function(callback) {
    var requestFn = window.requestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      requestAnimationFrameShim
    requestFn.call(window, callback)
  }
  Waypoint.Context = Context
}())

},{}],15:[function(require,module,exports){
(function() {
  'use strict'

  function byTriggerPoint(a, b) {
    return a.triggerPoint - b.triggerPoint
  }

  function byReverseTriggerPoint(a, b) {
    return b.triggerPoint - a.triggerPoint
  }

  var groups = {
    vertical: {},
    horizontal: {}
  }
  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/api/group */
  function Group(options) {
    this.name = options.name
    this.axis = options.axis
    this.id = this.name + '-' + this.axis
    this.waypoints = []
    this.clearTriggerQueues()
    groups[this.axis][this.name] = this
  }

  /* Private */
  Group.prototype.add = function(waypoint) {
    this.waypoints.push(waypoint)
  }

  /* Private */
  Group.prototype.clearTriggerQueues = function() {
    this.triggerQueues = {
      up: [],
      down: [],
      left: [],
      right: []
    }
  }

  /* Private */
  Group.prototype.flushTriggers = function() {
    for (var direction in this.triggerQueues) {
      var waypoints = this.triggerQueues[direction]
      var reverse = direction === 'up' || direction === 'left'
      waypoints.sort(reverse ? byReverseTriggerPoint : byTriggerPoint)
      for (var i = 0, end = waypoints.length; i < end; i += 1) {
        var waypoint = waypoints[i]
        if (waypoint.options.continuous || i === waypoints.length - 1) {
          waypoint.trigger([direction])
        }
      }
    }
    this.clearTriggerQueues()
  }

  /* Private */
  Group.prototype.next = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    var isLast = index === this.waypoints.length - 1
    return isLast ? null : this.waypoints[index + 1]
  }

  /* Private */
  Group.prototype.previous = function(waypoint) {
    this.waypoints.sort(byTriggerPoint)
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    return index ? this.waypoints[index - 1] : null
  }

  /* Private */
  Group.prototype.queueTrigger = function(waypoint, direction) {
    this.triggerQueues[direction].push(waypoint)
  }

  /* Private */
  Group.prototype.remove = function(waypoint) {
    var index = Waypoint.Adapter.inArray(waypoint, this.waypoints)
    if (index > -1) {
      this.waypoints.splice(index, 1)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/first */
  Group.prototype.first = function() {
    return this.waypoints[0]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/last */
  Group.prototype.last = function() {
    return this.waypoints[this.waypoints.length - 1]
  }

  /* Private */
  Group.findOrCreate = function(options) {
    return groups[options.axis][options.name] || new Group(options)
  }

  Waypoint.Group = Group
}())

},{}],16:[function(require,module,exports){
(function() {
  'use strict'

  function noop() {}

  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/shortcuts/inview */
  function Inview(options) {
    this.options = Waypoint.Adapter.extend({}, Inview.defaults, options)
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
    this.waypoints = []
    this.element = this.options.element
    this.createWaypoints()
  }

  /* Private */
  Inview.prototype.createWaypoints = function() {
    var configs = {
      vertical: [{
        down: 'enter',
        up: 'exited',
        offset: '100%'
      }, {
        down: 'entered',
        up: 'exit',
        offset: 'bottom-in-view'
      }, {
        down: 'exit',
        up: 'entered',
        offset: 0
      }, {
        down: 'exited',
        up: 'enter',
        offset: function() {
          return -this.adapter.outerHeight()
        }
      }],
      horizontal: [{
        right: 'enter',
        left: 'exited',
        offset: '100%'
      }, {
        right: 'entered',
        left: 'exit',
        offset: 'right-in-view'
      }, {
        right: 'exit',
        left: 'entered',
        offset: 0
      }, {
        right: 'exited',
        left: 'enter',
        offset: function() {
          return -this.adapter.outerWidth()
        }
      }]
    }

    for (var i = 0, end = configs[this.axis].length; i < end; i++) {
      var config = configs[this.axis][i]
      this.createWaypoint(config)
    }
  }

  /* Private */
  Inview.prototype.createWaypoint = function(config) {
    var self = this
    this.waypoints.push(new Waypoint({
      context: this.options.context,
      element: this.options.element,
      enabled: this.options.enabled,
      handler: (function(config) {
        return function(direction) {
          self.options[config[direction]].call(self, direction)
        }
      }(config)),
      offset: config.offset,
      horizontal: this.options.horizontal
    }))
  }

  /* Public */
  Inview.prototype.destroy = function() {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].destroy()
    }
    this.waypoints = []
  }

  Inview.prototype.disable = function() {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].disable()
    }
  }

  Inview.prototype.enable = function() {
    for (var i = 0, end = this.waypoints.length; i < end; i++) {
      this.waypoints[i].enable()
    }
  }

  Inview.defaults = {
    context: window,
    enabled: true,
    enter: noop,
    entered: noop,
    exit: noop,
    exited: noop
  }

  Waypoint.Inview = Inview
}())

},{}],17:[function(require,module,exports){
(function() {
  'use strict'

  var $ = window.jQuery
  var Waypoint = window.Waypoint

  /* http://imakewebthings.com/waypoints/shortcuts/sticky-elements */
  function Sticky(options) {
    this.options = $.extend({}, Waypoint.defaults, Sticky.defaults, options)
    this.element = this.options.element
    this.$element = $(this.element)
    this.createWrapper()
    this.createWaypoint()
  }

  /* Private */
  Sticky.prototype.createWaypoint = function() {
    var originalHandler = this.options.handler

    this.waypoint = new Waypoint($.extend({}, this.options, {
      element: this.wrapper,
      handler: $.proxy(function(direction) {
        var shouldBeStuck = this.options.direction.indexOf(direction) > -1
        var wrapperHeight = shouldBeStuck ? this.$element.outerHeight(true) : ''

        this.$wrapper.height(wrapperHeight)
        this.$element.toggleClass(this.options.stuckClass, shouldBeStuck)

        if (originalHandler) {
          originalHandler.call(this, direction)
        }
      }, this)
    }))
  }

  /* Private */
  Sticky.prototype.createWrapper = function() {
    if (this.options.wrapper) {
      this.$element.wrap(this.options.wrapper)
    }
    this.$wrapper = this.$element.parent()
    this.wrapper = this.$wrapper[0]
  }

  /* Public */
  Sticky.prototype.destroy = function() {
    if (this.$element.parent()[0] === this.wrapper) {
      this.waypoint.destroy()
      this.$element.removeClass(this.options.stuckClass)
      if (this.options.wrapper) {
        this.$element.unwrap()
      }
    }
  }

  Sticky.defaults = {
    wrapper: '<div class="sticky-wrapper" />',
    stuckClass: 'stuck',
    direction: 'down right'
  }

  Waypoint.Sticky = Sticky
}())

},{}],18:[function(require,module,exports){
(function() {
  'use strict'

  var keyCounter = 0
  var allWaypoints = {}

  /* http://imakewebthings.com/waypoints/api/waypoint */
  function Waypoint(options) {
    if (!options) {
      throw new Error('No options passed to Waypoint constructor')
    }
    if (!options.element) {
      throw new Error('No element option passed to Waypoint constructor')
    }
    if (!options.handler) {
      throw new Error('No handler option passed to Waypoint constructor')
    }

    this.key = 'waypoint-' + keyCounter
    this.options = Waypoint.Adapter.extend({}, Waypoint.defaults, options)
    this.element = this.options.element
    this.adapter = new Waypoint.Adapter(this.element)
    this.callback = options.handler
    this.axis = this.options.horizontal ? 'horizontal' : 'vertical'
    this.enabled = this.options.enabled
    this.triggerPoint = null
    this.group = Waypoint.Group.findOrCreate({
      name: this.options.group,
      axis: this.axis
    })
    this.context = Waypoint.Context.findOrCreateByElement(this.options.context)

    if (Waypoint.offsetAliases[this.options.offset]) {
      this.options.offset = Waypoint.offsetAliases[this.options.offset]
    }
    this.group.add(this)
    this.context.add(this)
    allWaypoints[this.key] = this
    keyCounter += 1
  }

  /* Private */
  Waypoint.prototype.queueTrigger = function(direction) {
    this.group.queueTrigger(this, direction)
  }

  /* Private */
  Waypoint.prototype.trigger = function(args) {
    if (!this.enabled) {
      return
    }
    if (this.callback) {
      this.callback.apply(this, args)
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy */
  Waypoint.prototype.destroy = function() {
    this.context.remove(this)
    this.group.remove(this)
    delete allWaypoints[this.key]
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable */
  Waypoint.prototype.disable = function() {
    this.enabled = false
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable */
  Waypoint.prototype.enable = function() {
    this.context.refresh()
    this.enabled = true
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/next */
  Waypoint.prototype.next = function() {
    return this.group.next(this)
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/previous */
  Waypoint.prototype.previous = function() {
    return this.group.previous(this)
  }

  /* Private */
  Waypoint.invokeAll = function(method) {
    var allWaypointsArray = []
    for (var waypointKey in allWaypoints) {
      allWaypointsArray.push(allWaypoints[waypointKey])
    }
    for (var i = 0, end = allWaypointsArray.length; i < end; i++) {
      allWaypointsArray[i][method]()
    }
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/destroy-all */
  Waypoint.destroyAll = function() {
    Waypoint.invokeAll('destroy')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/disable-all */
  Waypoint.disableAll = function() {
    Waypoint.invokeAll('disable')
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/enable-all */
  Waypoint.enableAll = function() {
    Waypoint.Context.refreshAll()
    for (var waypointKey in allWaypoints) {
      allWaypoints[waypointKey].enabled = true
    }
    return this
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/refresh-all */
  Waypoint.refreshAll = function() {
    Waypoint.Context.refreshAll()
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-height */
  Waypoint.viewportHeight = function() {
    return window.innerHeight || document.documentElement.clientHeight
  }

  /* Public */
  /* http://imakewebthings.com/waypoints/api/viewport-width */
  Waypoint.viewportWidth = function() {
    return document.documentElement.clientWidth
  }

  Waypoint.adapters = []

  Waypoint.defaults = {
    context: window,
    continuous: true,
    enabled: true,
    group: 'default',
    horizontal: false,
    offset: 0
  }

  Waypoint.offsetAliases = {
    'bottom-in-view': function() {
      return this.context.innerHeight() - this.adapter.outerHeight()
    },
    'right-in-view': function() {
      return this.context.innerWidth() - this.adapter.outerWidth()
    }
  }

  window.Waypoint = Waypoint
}())

},{}]},{},[1]);
